import React from 'react';
import PropTypes from 'prop-types';
import { __ } from '../../Lang.js'; // Add translation function import

const VideoTopNavigation = ({ nextVideo }) => {
  const toUrl = nextVideo?.permalinks?.web || null;

  return (
  <div className="video-header">
    <div className="video-breadcrumbs-left">
    <div className="video-top-navigation">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.history.back();
          }}
          className="video-breadcrumb-link"
        >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
          {__('Back')}
        </a>
          </div>
        </div>

          {toUrl && (
            <a href={toUrl} className="video-next-button">
              {__('NEXT')}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          )}
    </div>
   );
};

VideoTopNavigation.propTypes = {
  nextVideo: PropTypes.object,
};

export default VideoTopNavigation;